/*
 * Настройки чата для АДМИНКИ. Файлы чата (ChatCore, ChatMessages, InputChatUI
 * и другие в этой папке) одинаковые в админке и на фронте — всё, чем
 * проекты отличаются, собрано здесь. У фронта этот файл свой.
 */

// «В задачу»: задачи есть только в админке.
export { TodoFromMessageModal } from "../Todo/TodoChatModals";

// Товары каталога и заказы сайта можно отправить в любой чат.
export const CHAT_SITE_CATALOG = true;

// Какие документы предлагает «Файлы» (пусто — любые).
export const CHAT_DOCUMENT_ACCEPT = "";

// Профиль участника (имя в шапке и в группе): у админа — все данные пользователя.
export { default as ChatUserProfileModal } from "./AdminUserProfileModal";

// Плавающего окна чата в админке нет.
export const openChatFloating = null;

// Прочитали чат — больше ничего отмечать не нужно.
export const useChatReadExtras = () => null;
